import { STUDY_TOOL_CACHE_PREFIX } from '@/auth/studyToolCache';
import { EXPERIENCE_KID_ID } from './mode';
/** Clear only this fictional learner's tab drafts. Real storage and auth are never selected. */
export function clearStudyDemoDrafts(storage: Storage = sessionStorage) {
  try {
    const prefixes = [
      `${STUDY_TOOL_CACHE_PREFIX}working:${EXPERIENCE_KID_ID}:`,
      `airbotix.study.material-note-draft.${EXPERIENCE_KID_ID}:`,
      `airbotix.study.operation.${EXPERIENCE_KID_ID}:`,
    ];
    for (const key of Object.keys(storage))
      if (prefixes.some((prefix) => key.startsWith(prefix))) storage.removeItem(key);
  } catch {
    /* The in-memory example session still works without browser storage. */
  }
}
export function studyDemoReturnTo(search: string, origin: string) {
  const requested = new URLSearchParams(search).get('returnTo');
  if (!requested || !requested.startsWith('/') || requested.startsWith('//')) return '/try/study';
  try {
    const target = new URL(requested, origin);
    return target.origin === origin &&
      (target.pathname === '/try/study' ||
        target.pathname === '/learn/study' ||
        target.pathname.startsWith('/learn/study/'))
      ? target.pathname + target.search + target.hash
      : '/try/study';
  } catch {
    return '/try/study';
  }
}
